import { render, staticRenderFns } from "./AccountSwitcher.vue?vue&type=template&id=19cdd279&scoped=true"
import script from "./AccountSwitcher.vue?vue&type=script&lang=ts"
export * from "./AccountSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./AccountSwitcher.vue?vue&type=style&index=0&id=19cdd279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdd279",
  null
  
)

export default component.exports